import { render, staticRenderFns } from "./AutorizationPage.vue?vue&type=template&id=0f5047dc&"
import script from "./AutorizationPage.vue?vue&type=script&lang=js&"
export * from "./AutorizationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports